import {
  VISION_PLANS_REQUESTED,
  DENTAL_PLANS_REQUESTED,
  LIFE_PLANS_REQUESTED,
  ALL_DENTAL_PLANS_REQUESTED,
  UPDATE_DENTAL_PLANS,
  UPDATE_ALL_DENTAL_PLANS,
  UPDATE_VISION_PLANS,
  UPDATE_LIFE_PLANS,
  UPDATE_CART_PLANS,
  UPDATE_MEC_PLANS,
  UPDATE_MVP_PLANS,
  SHOW_EXTRA_PLANS,
  HIDE_EXTRA_PLANS,
} from "QuotePage/Actions";
import _ from "underscore";

import { mergePlans } from "Common/PlanLoader";

export function dentalPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_DENTAL_PLANS:
      return mergePlans(state, action.plans);
    case UPDATE_CART_PLANS:
      return mergePlans(state, action.plans.dental.results);
    default:
      return state;
  }
}

export function loadingDentalPlans(state = false, action) {
  switch (action.type) {
    case DENTAL_PLANS_REQUESTED:
      return true;
    case UPDATE_DENTAL_PLANS:
      return false;
    default:
      return state;
  }
}

export function allDentalPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_ALL_DENTAL_PLANS:
      return mergePlans(state, action.plans);
    default:
      return state;
  }
}

export function isLoadingAllDentalPlans(state = null, action) {
  switch (action.type) {
    case ALL_DENTAL_PLANS_REQUESTED:
      // Only allow loading state to be flipped once
      return state === null ? true : state;
    case UPDATE_ALL_DENTAL_PLANS:
      return false;
    default:
      return state;
  }
}

export function carriersInRegion(state = [], action) {
  switch (action.type) {
    default:
      return state;
  }
}

export function visionPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_VISION_PLANS:
      return mergePlans(state, action.plans);
    case UPDATE_CART_PLANS:
      return mergePlans(state, action.plans.vision.results);
    default:
      return state;
  }
}

export function loadingVisionPlans(state = false, action) {
  switch (action.type) {
    case VISION_PLANS_REQUESTED:
      return true;
    case UPDATE_VISION_PLANS:
      return false;
    default:
      return state;
  }
}

export function lifePlans(state = [], action) {
  switch (action.type) {
    case UPDATE_LIFE_PLANS:
      return mergePlans(state, action.plans);
    case UPDATE_CART_PLANS:
      return mergePlans(state, action.plans.vision.results);
    default:
      return state;
  }
}

export function loadingLifePlans(state = false, action) {
  switch (action.type) {
    case LIFE_PLANS_REQUESTED:
      return true;
    case UPDATE_LIFE_PLANS:
      return false;
    default:
      return state;
  }
}

export function medicalPlans(state = [], action) {
  switch (action.type) {
    default:
      return state;
  }
}

export function mecPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_MEC_PLANS:
      return mergePlans(state, action.plans);
    default:
      return state;
  }
}

export function mvpPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_MVP_PLANS:
      return mergePlans(state, action.plans);
    default:
      return state;
  }
}

export function isShowingExtraPlans(state = false, action) {
  switch (action.type) {
    case SHOW_EXTRA_PLANS:
      return true;
    case HIDE_EXTRA_PLANS:
      return false;
    default:
      return state;
  }
}
